import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=0c45d1e5&scoped=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=0c45d1e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45d1e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c45d1e5')) {
      api.createRecord('0c45d1e5', component.options)
    } else {
      api.reload('0c45d1e5', component.options)
    }
    module.hot.accept("./PanelGroup.vue?vue&type=template&id=0c45d1e5&scoped=true", function () {
      api.rerender('0c45d1e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/agent/components/PanelGroup.vue"
export default component.exports